import Swal from "sweetalert2";

/**
 * Muestra un modal de confirmación con solo botones (sin input).
 *
 * @param {Function} callback - Función a ejecutar si se confirma.
 * @param {Object} options - Opciones de personalización.
 * @param {string} [options.title="¿Estás seguro?"] - Título del modal.
 * @param {string} [options.text="Esta acción no se puede deshacer."] - Texto del modal.
 * @param {string} [options.confirmText="Sí, continuar"] - Texto del botón de confirmación.
 * @param {boolean} [options.allowOutsideClick=true] - Permitir cerrar haciendo clic fuera.
 * @param {boolean} [options.allowEnterKey=true] - Permitir confirmar con Enter.
 */
export const confirmActionModal = async (
    callback = () => {},
    {
        title = "¿Estás seguro?",
        text = "Esta acción no se puede deshacer.",
        confirmText = "Continuar",
        allowOutsideClick = true,
        allowEnterKey = true,
    } = {}
) => {
    const result = await Swal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: confirmText,
        confirmButtonColor: "#2e4a6c",
        cancelButtonColor: "#6c757d",
    });

    if (result.isConfirmed) {
        await callback();
    }
};
